function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @module AppTree */
import React from "react";
import ReactDOM from "react-dom";
import { DashIcon } from "./";
import renderOrderMenu from "../others/renderOrderMenu";
import renderSortMenu, { RearrangeBox } from "../others/renderSortMenu";
import AIOTree, { getTreeParentById, getRecursivelyCheckedNodes, immer } from "react-aiot";
import { message, Icon, Popconfirm, Alert } from "react-aiot";
import { hooks, rmlOpts, i18n, urlParam, addUrlParam, isMaterialWp, materialWpResizeOpposite, ICON_OBJ_FOLDER_CLOSED, ICON_OBJ_FOLDER_OPEN, ICON_OBJ_FOLDER_COLLECTION, ICON_OBJ_FOLDER_GALLERY, resolveIcon, request } from "../util";
import { draggable, droppable } from "../util/dragdrop";
import $ from "jquery";
import { FILTER_SELECTOR } from "../others/filter";
import createLockedToolTipText from "../hooks/permissions";
import { inject, observer, Observer } from "mobx-react";
import { toggleSortable, orderUrl } from "../hooks/sortable";
import MetaBox from "../components/MetaBox";
import { getDefaultFolder, ID_NONE } from "../others/defaultFolder";
import { ProFooter, ProBox } from "../components/ProFooter";
import { isRatable, RatingPointer } from "@devowl-wp/real-utils";
/**
 * The latest queried folder.
 *
 * @deprecated Do no longer use it, use rmlOpts.others.lastQueried instead
 * @type object
 */

export var latestQueriedFolder = {
  node: null
};
message.config({
  top: 50
});
/**
 * The application tree handler for Real Media Library.
 *
 * @param {string} id The HTML id (needed to localStorage support)
 * @param {object} [attachmentsBrowser] The attachments browser (for media grid view)
 * @param {boolean} [isModal=false] If true the given app tree is a modal dialog
 * @param {module:AppTree~AppTree~init} [init]
 * @see module:store.StoredAppTree
 * @see module:react-aiot~Tree
 * @extends React.Component
 */

var AppTree = (_dec = inject("store"), _dec(_class = observer(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(AppTree, _React$Component);

  var _super = _createSuper(AppTree);

  /**
   * Initialize properties and state for AIOTree component.
   * Also handles the responsiveness.
   */
  function AppTree(_props) {
    var _this;

    _classCallCheck(this, AppTree);

    _this = _super.call(this, _props); // Add respnsive handler for non-modal views

    _this.renderToolbarButtons = function (multi) {
      var availableToolbarButtons = multi ? _this.state.availableMultiToolbarButtons : _this.state.availableToolbarButtons,
          toolbarBackButton = _this.state.toolbarBackButton;
      var toolbar = {
        buttons: {},
        backButton: _this.resolveStateRefs(toolbarBackButton, "keysToolbar")
      };

      for (var i = 0; i < availableToolbarButtons.length; i++) {
        toolbar.buttons[availableToolbarButtons[i]] = _this.resolveStateRefs(_this.state[(multi ? "multiToolbar_" : "toolbar_") + availableToolbarButtons[i]], "keysToolbar");
      }

      return toolbar;
    };

    _this.renderCreatables = function () {
      var _this$state = _this.state,
          availableCreatables = _this$state.availableCreatables,
          creatableBackButton = _this$state.creatableBackButton,
          creatable = {
        buttons: {},
        backButton: _this.resolveStateRefs(creatableBackButton, "keysCreatable")
      };

      for (var i = 0; i < availableCreatables.length; i++) {
        creatable.buttons[availableCreatables[i]] = _this.resolveStateRefs(_this.state["creatable_" + availableCreatables[i]], "keysCreatable");
      }

      return creatable;
    };

    _this.doRef = function (ref) {
      return _this.ref = ref;
    };

    _this.handleCloseMultiToolbar = function (checkedNodes) {
      checkedNodes.forEach(function (n) {
        return n.toggleChecked(false, false);
      });
    };

    _this.handleCreatableClick = function (type, typeInt) {
      _this._lastHandleCreatableClickArgs = [type, typeInt]; // @see handleAddClose

      var createRoot = undefined,
          $create = undefined;

      if (type) {
        // Activate create
        var creatable = _this.state["creatable_" + type],
            newNode = {
          $rename: true,
          icon: _this.resolveStateRef(creatable.icon),
          iconActive: _this.resolveStateRef(creatable.iconActive),
          parent: +rmlOpts.others.rootId,
          typeInt: typeInt
        },
            selectedId = _this.getSelectedId();

        if (typeof selectedId !== "number" || [+rmlOpts.others.rootId, ID_NONE].indexOf(selectedId) > -1) {
          createRoot = newNode;
        } else {
          $create = newNode;
          newNode.parent = selectedId;
        }
      }

      _this.setState({
        isTreeLinkDisabled: !!type,
        isCreatableLinkCancel: !!type,
        isToolbarActive: !type,
        createRoot: createRoot
      });

      _this.updateTreeItemById(function (node) {
        node.$create = $create;
      });
    };

    _this.handleDelayedDroppable = function () {
      clearTimeout(_this.timeout);
      _this.timeout = setTimeout(function () {
        return droppable(_assertThisInitialized(_this));
      }, 200);
    };

    _this.handleCheck = function (id) {
      _this.props.store.getTreeItemById(id).toggleChecked();
    };

    _this.handleSelect = function (id) {
      // Do nothing when sort mode is active
      if (_this.state.toolbarActiveButton === "sort") {
        return;
      }

      var select = _this.getTreeItemById(id, false),
          setter = function setter(_id, $busy) {
        latestQueriedFolder.node = select;
        latestQueriedFolder.node.setter(function (node) {
          node.$busy = $busy;
          node.selected = true;
        });
        rmlOpts.others.lastQueried = select.id;
        /**
         * The user is selecting a node in the app tree.
         *
         * @event module:util/hooks#tree/select
         * @param {int|string} id
         * @param {object} select The MST node
         * @param {object} attachmentsBrowser
         * @this module:AppTree~AppTree
         * @since 4.0.5
         */

        hooks.call("tree/select", [_id, select, _this.attachmentsBrowser], _assertThisInitialized(_this));
      };

      if (_this.attachmentsBrowser) {
        !id && _this.attachmentsBrowser.collection.props.set({
          ignore: +new Date()
        }); // Reload the view

        _this._handleBackboneFilterSelection(select.id);
      } else {
        var keepParams = ["page", "paged"].map(function (param) {
          return {
            param: param,
            value: urlParam(param)
          };
        }).filter(function (_ref) {
          var value = _ref.value;
          return value !== null;
        });
        var href = window.location.href;
        urlParam("orderby") === "rml" && (href = href.split("?")[0]);

        var _iterator = _createForOfIteratorHelper(keepParams),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _step.value,
                param = _step$value.param,
                value = _step$value.value;
            href = addUrlParam(href, param, value);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        select.properties && (select.contentCustomOrder === 1 || select.forceCustomOrder) && (href = orderUrl(href));
        window.location.href = addUrlParam(href, "rml_folder", select.id);
      }

      setter(select.id, !_this.attachmentsBrowser);
    };

    _this.handleResize = function () {
      var _attachmentsBrowser$a;

      var _assertThisInitialize = _assertThisInitialized(_this),
          attachmentsBrowser = _assertThisInitialize.attachmentsBrowser;

      attachmentsBrowser === null || attachmentsBrowser === void 0 ? void 0 : (_attachmentsBrowser$a = attachmentsBrowser.attachments) === null || _attachmentsBrowser$a === void 0 ? void 0 : _attachmentsBrowser$a.setColumns();
    };

    _this.handleOrderClick = function () {
      if (!rmlOpts.others.isPro && rmlOpts.others.showProHints) {
        _this.setState({
          showProFeature: "order-content"
        });
      } else {
        if (toggleSortable(_this.getTreeItemById(), true, _this.attachmentsBrowser)) {
          _this.setState({
            isMoveable: false,
            toolbarActiveButton: "order",
            toolbarBackButton: Object.assign(_this.state.toolbarBackButton, {
              label: "i18n.back"
            })
          });
        }
      }
    };

    _this.handleOrderCancel = function () {
      toggleSortable(_this.getTreeItemById(), false, _this.attachmentsBrowser);

      _this.setState({
        isMoveable: true,
        toolbarActiveButton: undefined,
        toolbarBackButton: Object.assign(_this.state.toolbarBackButton, {
          label: "i18n.cancel"
        })
      });
    };

    _this.handleRenameClick = function () {
      return _this._handleRenameNode("rename", true, true, true);
    };

    _this.handleRenameCancel = function () {
      return _this._handleRenameNode(undefined, false, false, undefined);
    };

    _this.handleRenameClose = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(save, inputValue, _ref2) {
        var id, title, hide, node, _yield$node$setName, name;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref2.id, title = _ref2.title;

                if (!(save && inputValue.length && title !== inputValue)) {
                  _context.next = 22;
                  break;
                }

                hide = message.loading(i18n("renameLoadingText", {
                  name: inputValue
                }));
                _context.prev = 3;
                node = _this.props.store.getTreeItemById(id);
                _context.next = 7;
                return node.setName(inputValue);

              case 7:
                _yield$node$setName = _context.sent;
                name = _yield$node$setName.name;

                /**
                 * Folder successfully renamed.
                 *
                 * @event module:util/hooks#folder/renamed
                 * @param {module:store/TreeNode~TreeNode} node The node
                 * @this module:AppTree~AppTree
                 * @since 4.0.7
                 */
                hooks.call("folder/renamed", [node], _assertThisInitialized(_this));
                message.success(i18n("renameSuccess", {
                  name: name
                }));

                _this.handleRenameCancel();

                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                message.error(_context.t0.responseJSON.message);

              case 17:
                _context.prev = 17;
                hide();
                return _context.finish(17);

              case 20:
                _context.next = 23;
                break;

              case 22:
                _this.handleRenameCancel();

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 14, 17, 20]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.handleAddClose = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(save, name, _ref4) {
        var parent, typeInt, hide, ctrlHolding, newObj, backboneFilter, lastSlugs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                parent = _ref4.parent, typeInt = _ref4.typeInt;

                if (!save) {
                  _context2.next = 26;
                  break;
                }

                if (!(process.env.PLUGIN_CTX === "lite" && parent !== _this.props.store.rootId)) {
                  _context2.next = 5;
                  break;
                }

                _this.setState({
                  showProFeature: "subfolder"
                });

                return _context2.abrupt("return");

              case 5:
                _this.updateCreateNode(function (obj) {
                  obj.$busy = true;
                });

                hide = message.loading(i18n("addLoadingText", {
                  name: name
                })), ctrlHolding = $("body").hasClass("aiot-helper-ctrl");
                _context2.prev = 7;
                _context2.next = 10;
                return _this.props.store.persist(name, {
                  parent: parent,
                  typeInt: typeInt
                }, function () {
                  if (ctrlHolding) {
                    var _this2;

                    // Allow bulk insert while holding ctrl + enter
                    (_this2 = _this).handleCreatableClick.apply(_this2, _toConsumableArray(_this._lastHandleCreatableClickArgs));
                  } else {
                    _this.handleCreatableClick();
                  }
                });

              case 10:
                newObj = _context2.sent;
                // Show rating pointer
                isRatable(rmlOpts.slug) && _this.ref && new RatingPointer(rmlOpts.slug, $(_this.ref.container).find(".aiot-tree-headline"));
                message.success(i18n("addSuccess", {
                  name: name
                })); // Modify all available attachments browsers filter

                $(FILTER_SELECTOR).each(function () {
                  backboneFilter = $(this).data("backboneView");

                  if (backboneFilter) {
                    lastSlugs = backboneFilter.lastSlugs;
                    lastSlugs.names.push("(NEW) " + name);
                    lastSlugs.slugs.push(newObj.id);
                    lastSlugs.types.push(typeInt);
                    backboneFilter.createFilters(lastSlugs);
                  }
                });
                !ctrlHolding && droppable(_assertThisInitialized(_this));
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](7);

                if (_context2.t0.responseJSON.code === "rest_rml_only_pro") {
                  message.error(_context2.t0.responseJSON.message);
                }

                _this.updateCreateNode(function (obj) {
                  obj.$busy = false;
                });

              case 21:
                _context2.prev = 21;
                hide();
                return _context2.finish(21);

              case 24:
                _context2.next = 27;
                break;

              case 26:
                _this.handleCreatableClick();

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[7, 17, 21, 24]]);
      }));

      return function (_x4, _x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.handleTrash = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var node,
            isMulti,
            hide,
            parentId,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                node = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : _this.getTreeItemById();
                isMulti = _args3.length > 2 ? _args3[2] : undefined;

                if (!node.childNodes.filter(function (node) {
                  return node.$visible;
                }).length) {
                  _context3.next = 5;
                  break;
                }

                message.error(i18n("deleteFailedSub", {
                  name: node.title
                }));
                return _context3.abrupt("return", false);

              case 5:
                hide = message.loading(i18n("deleteLoadingText", {
                  name: node.title
                }));
                _context3.prev = 6;
                _context3.next = 9;
                return node.trash();

              case 9:
                !isMulti && message.success(i18n("deleteSuccess", {
                  name: node.title
                }));
                /**
                 * A folder has been deleted.
                 *
                 * @event module:util/hooks#tree/select
                 * @param {module:store/TreeNode~TreeNode} node The node
                 * @param {object} attachmentsBrowser
                 * @this module:AppTree~AppTree
                 * @since 4.0.7
                 */

                hooks.call("folder/deleted", [node, _this.attachmentsBrowser], _assertThisInitialized(_this)); // Select parent

                if (!isMulti) {
                  parentId = getTreeParentById(node.id, _this.props.store.tree);

                  _this.handleSelect(parentId === 0 ? +rmlOpts.others.rootId : parentId);
                }

                return _context3.abrupt("return", true);

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](6);
                message.error(_context3.t0.responseJSON.message);
                return _context3.abrupt("return", false);

              case 19:
                _context3.prev = 19;
                hide();
                return _context3.finish(19);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[6, 15, 19, 22]]);
      }));

      return function (_x7) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.handleMultipleTrash = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var count, checkedNodes, _iterator2, _step2, nodes, _iterator3, _step3, node, result;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              count = 0;

              _this.setState({
                isTreeBusy: true
              });

              checkedNodes = getRecursivelyCheckedNodes(_this.props.store.tree, true);

              _this.handleSelect(+rmlOpts.others.rootId);

              _iterator2 = _createForOfIteratorHelper(Object.values(checkedNodes).reverse());
              _context4.prev = 5;

              _iterator2.s();

            case 7:
              if ((_step2 = _iterator2.n()).done) {
                _context4.next = 33;
                break;
              }

              nodes = _step2.value;
              _iterator3 = _createForOfIteratorHelper(nodes);
              _context4.prev = 10;

              _iterator3.s();

            case 12:
              if ((_step3 = _iterator3.n()).done) {
                _context4.next = 23;
                break;
              }

              node = _step3.value;
              count++;
              _context4.next = 17;
              return _this.handleTrash(null, node, true);

            case 17:
              result = _context4.sent;

              if (result) {
                _context4.next = 21;
                break;
              }

              _this.setState({
                isTreeBusy: false
              });

              return _context4.abrupt("return");

            case 21:
              _context4.next = 12;
              break;

            case 23:
              _context4.next = 28;
              break;

            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](10);

              _iterator3.e(_context4.t0);

            case 28:
              _context4.prev = 28;

              _iterator3.f();

              return _context4.finish(28);

            case 31:
              _context4.next = 7;
              break;

            case 33:
              _context4.next = 38;
              break;

            case 35:
              _context4.prev = 35;
              _context4.t1 = _context4["catch"](5);

              _iterator2.e(_context4.t1);

            case 38:
              _context4.prev = 38;

              _iterator2.f();

              return _context4.finish(38);

            case 41:
              message.success(i18n("deleteMultipleSuccess", {
                count: count
              }));

              _this.setState({
                isTreeBusy: false
              });

            case 43:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[5, 35, 38, 41], [10, 25, 28, 31]]);
    }));
    _this.handleSortManual = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _this3;

      var _len,
          args,
          _key,
          result,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              for (_len = _args5.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args5[_key];
              }

              if (!(process.env.PLUGIN_CTX === "lite" && args.parentToId !== _this.props.store.rootId && args.parentToId !== undefined)) {
                _context5.next = 4;
                break;
              }

              _this.setState({
                showProFeature: "subfolder"
              });

              return _context5.abrupt("return", false);

            case 4:
              _context5.next = 6;
              return (_this3 = _this).handleSort.apply(_this3, args);

            case 6:
              result = _context5.sent;
              result && _this.setState({
                rearrangeBoxId: false,
                isSortableBusy: false,
                isToolbarBusy: false
              });
              return _context5.abrupt("return", result);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    _this.handleSort = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref9) {
        var _ref9$doFinally, doFinally, props, store, hide, toolbarActiveButton, parentFromId, parentToId;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref9$doFinally = _ref9.doFinally, doFinally = _ref9$doFinally === void 0 ? true : _ref9$doFinally, props = _objectWithoutProperties(_ref9, ["doFinally"]);
                store = _this.props.store;

                if (!(process.env.PLUGIN_CTX === "lite" && props.parentToId !== store.rootId)) {
                  _context6.next = 7;
                  break;
                }

                // Revert changes in UI (first move, afterwards cancel to update the observable correctly)
                store.handleSort(_objectSpread(_objectSpread({}, props), {}, {
                  request: false
                }));
                store.handleSort({
                  id: props.id,
                  oldIndex: props.newIndex,
                  newIndex: props.oldIndex,
                  parentFromId: props.parentToId,
                  parentToId: props.parentFromId,
                  request: false
                });

                _this.setState({
                  showProFeature: "subfolder"
                });

                return _context6.abrupt("return", false);

              case 7:
                _this.setState({
                  isSortableBusy: true,
                  isToolbarBusy: true
                });

                hide = message.loading(i18n("sortLoadingText")), toolbarActiveButton = _this.state.toolbarActiveButton, parentFromId = props.parentFromId, parentToId = props.parentToId;
                _context6.prev = 9;
                _context6.next = 12;
                return store.handleSort(props);

              case 12:
                message.success(i18n("sortedSuccess"));

                if (parentFromId === parentToId) {
                  /**
                   * This action is called when a folder was relocated in the
                   * folder tree. That means the parent was not changed, only
                   * the order was changed.
                   *
                   * @event module:util/hooks#folder/relocated
                   * @param {object} props The move properties
                   * @this module:AppTree~AppTree
                   * @since 4.0.7
                   */
                  hooks.call("folder/relocated", [props], _assertThisInitialized(_this));
                } else {
                  /**
                   * This action is called when a folder was moved in the folder tree.
                   * That means the parent and order was changed.
                   *
                   * @event module:util/hooks#folder/moved
                   * @param {object} props The move properties
                   * @this module:AppTree~AppTree
                   * @since 4.0.7
                   */
                  hooks.call("folder/moved", [props], _assertThisInitialized(_this));
                }

                return _context6.abrupt("return", true);

              case 17:
                _context6.prev = 17;
                _context6.t0 = _context6["catch"](9);
                message.error(_context6.t0.responseJSON.message);
                return _context6.abrupt("return", false);

              case 21:
                _context6.prev = 21;
                hide();
                doFinally && _this._handleSortNode(toolbarActiveButton, false);
                return _context6.finish(21);

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[9, 17, 21, 25]]);
      }));

      return function (_x8) {
        return _ref10.apply(this, arguments);
      };
    }();

    _this.handleWindowResize = function () {
      var isMobile = _this._isMobile();

      _this.setState({
        isSticky: !isMobile,
        isStickyHeader: !isMobile,
        isResizable: !isMobile,
        isFullWidth: isMobile,
        style: isMobile ? {
          marginLeft: 10
        } : {}
      });
    };

    _this.handleReload = function () {
      _this.handleSelect();
    };

    _this.handleDismissLicenseNotice = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return request({
                location: {
                  path: "/notice/license",
                  method: "DELETE"
                }
              });

            case 2:
              window.location.reload();

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    _this.handleDismissImportTaxNotice = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return request({
                location: {
                  path: "/notice/import",
                  method: "DELETE"
                }
              });

            case 2:
              window.location.reload();

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    _this.onTreeNodeRender = function (createTreeNode, TreeNode, node) {
      return /*#__PURE__*/React.createElement(Observer, {
        key: node.id
      }, function () {
        return createTreeNode(node, {
          indeterminate: node.indeterminate
        });
      });
    };

    _this.onTreeNodeRenderIcon = function (icon) {
      return resolveIcon(icon);
    };

    _this._handleRenameNode = function (toolbarActiveButton, isCreatableLinkDisabled, isTreeLinkDisabled, nodeRename) {
      _this.setState({
        // Make other nodes editable / not editable
        isCreatableLinkDisabled: isCreatableLinkDisabled,
        isTreeLinkDisabled: isTreeLinkDisabled,
        toolbarActiveButton: toolbarActiveButton
      });

      _this.updateTreeItemById(function (node) {
        // Make selected node editable / not editable
        node.$rename = nodeRename;
      });
    };

    _this._isMobile = function () {
      return $(window).width() <= 700;
    };

    _this._handleSortNode = function (toolbarActiveButton, isBusy) {
      _this.setState({
        isCreatableLinkDisabled: !!toolbarActiveButton,
        toolbarActiveButton: toolbarActiveButton,
        isSortableDisabled: !toolbarActiveButton,
        toolbarBackButton: Object.assign(_this.state.toolbarBackButton, {
          label: "i18n." + (toolbarActiveButton ? "back" : "cancel")
        })
      });

      typeof isBusy === "boolean" && _this.setState({
        isSortableBusy: isBusy
      });
      typeof isBusy === "boolean" && _this.setState({
        isToolbarBusy: isBusy
      });
    };

    _this._handleDetails = function (action, status, response) {
      var metaBoxId = action ? action === "usersettings" ? action : _this.props.store.selectedId : false;

      _this.setState({
        metaBoxId: metaBoxId
      }); // When the metadata is saved successfully listen to the "reload" state and reload the current view.


      status === true && response && response.reload && _this.handleReload();
    };

    !_props.isModal && $(window).resize(_this.handleWindowResize);

    var _isMobile = _this._isMobile(); // State refs (see https://github.com/reactjs/redux/issues/1793) and #resolveStateRefs


    _this.stateRefs = {
      keysCreatable: "icon,iconActive,toolTipTitle,toolTipText,onClick,label".split(","),
      keysToolbar: "content,toolTipTitle,toolTipText,onClick,onCancel,onSave,modifier,label,save,menu".split(","),
      // Icons
      ICON_OBJ_FOLDER_CLOSED: ICON_OBJ_FOLDER_CLOSED,
      ICON_OBJ_FOLDER_OPEN: ICON_OBJ_FOLDER_OPEN,
      ICON_OBJ_FOLDER_COLLECTION: ICON_OBJ_FOLDER_COLLECTION,
      ICON_OBJ_FOLDER_GALLERY: ICON_OBJ_FOLDER_GALLERY,
      ICON_SETTINGS: /*#__PURE__*/React.createElement(Icon, {
        type: "setting"
      }),
      ICON_LOCKED: /*#__PURE__*/React.createElement(Icon, {
        type: "lock"
      }),
      ICON_ORDER: /*#__PURE__*/React.createElement(DashIcon, {
        name: "move"
      }),
      ICON_RELOAD: /*#__PURE__*/React.createElement(Icon, {
        type: "reload"
      }),
      ICON_RENAME: /*#__PURE__*/React.createElement(Icon, {
        type: "edit"
      }),
      ICON_TRASH: /*#__PURE__*/React.createElement(Icon, {
        type: "delete"
      }),
      ICON_SORT: /*#__PURE__*/React.createElement(DashIcon, {
        name: "sort"
      }),
      ICON_SAVE: /*#__PURE__*/React.createElement(Icon, {
        type: "save"
      }),
      ICON_ELLIPSIS: /*#__PURE__*/React.createElement(Icon, {
        type: "ellipsis"
      }),
      // Creatable
      handleCreatableClickBackButton: function handleCreatableClickBackButton() {
        return _this.handleCreatableClick();
      },
      handleCreatableClickFolder: function handleCreatableClickFolder() {
        return _this.handleCreatableClick("folder", 0);
      },
      handleCreatableClickCollection: rmlOpts.others.isPro ? function () {
        return _this.handleCreatableClick("collection", 1);
      } : function () {
        return _this.setState({
          showProFeature: "collections"
        });
      },
      handleCreatableClickGallery: function handleCreatableClickGallery() {
        return _this.handleCreatableClick("gallery", 2);
      },
      // Toolbar buttons
      renderOrderMenu: renderOrderMenu.bind(_assertThisInitialized(_this)),
      renderSortMenu: renderSortMenu.bind(_assertThisInitialized(_this)),
      handleOrderClick: _this.handleOrderClick,
      handleOrderCancel: _this.handleOrderCancel,
      handleReload: _this.handleReload,
      handleRenameClick: _this.handleRenameClick,
      handleRenameCancel: _this.handleRenameCancel,
      handleTrashModifier: function handleTrashModifier(body) {
        var node = _this.getTreeItemById();

        return node ? /*#__PURE__*/React.createElement(Popconfirm, {
          placement: "bottom",
          onConfirm: _this.handleTrash,
          title: i18n("deleteConfirm", {
            name: node.title
          }, "maxWidth"),
          okText: i18n("ok"),
          cancelText: i18n("cancel")
        }, body) : body;
      },
      handleMultipleTrashModifier: function handleMultipleTrashModifier(body) {
        var checkedNodes = getRecursivelyCheckedNodes(_this.props.store.tree);
        return /*#__PURE__*/React.createElement(Popconfirm, {
          placement: "bottom",
          onConfirm: _this.handleMultipleTrash,
          title: i18n("deleteMultipleConfirm", {
            count: checkedNodes.length
          }, "maxWidth"),
          okText: i18n("ok"),
          cancelText: i18n("cancel")
        }, body);
      },
      handleSortClick: function handleSortClick() {
        return _this._handleSortNode("sort");
      },
      handleSortCancel: function handleSortCancel() {
        return _this._handleSortNode();
      },
      handleDetailsClick: function handleDetailsClick() {
        return _this._handleDetails("details");
      },
      handleUserSettingsClick: function handleUserSettingsClick() {
        return _this._handleDetails("usersettings");
      }
    }; // Determine selected id and fetch tree

    var _selectedId = getDefaultFolder();

    _this.attachmentsBrowser = _props.attachmentsBrowser;
    _this.state = {
      // Custom
      currentFolderRestrictions: [],
      isModal: _props.isModal,
      isMoveable: true,
      isWPAttachmentsSortMode: false,
      // See modal.js
      initialSelectedId: !_selectedId || _selectedId === "all" ? "all" : +_selectedId,
      metaBoxId: false,
      rearrangeBoxId: false,
      showProFeature: undefined,
      // Creatables
      availableCreatables: (rmlOpts.others.isPro || rmlOpts.others.showProHints ? "folder,collection,gallery" : "folder").split(","),
      selectedCreatableType: undefined,
      // The selected folder type
      creatable_folder: {
        icon: "ICON_OBJ_FOLDER_CLOSED",
        iconActive: "ICON_OBJ_FOLDER_OPEN",
        visibleInFolderType: [undefined, 0],
        cssClasses: "page-title-action add-new-h2",
        toolTipTitle: "i18n.creatable0ToolTipTitle",
        toolTipText: "i18n.creatable0ToolTipText",
        label: "+",
        onClick: "handleCreatableClickFolder"
      },
      creatable_collection: {
        icon: "ICON_OBJ_FOLDER_COLLECTION",
        visibleInFolderType: [undefined, 0, 1],
        cssClasses: "page-title-action add-new-h2",
        toolTipTitle: "i18n.creatable1ToolTipTitle",
        toolTipText: "i18n.creatable1ToolTipText",
        label: "+",
        onClick: "handleCreatableClickCollection"
      },
      creatable_gallery: {
        icon: "ICON_OBJ_FOLDER_GALLERY",
        visibleInFolderType: [1],
        visible: false,
        cssClasses: "page-title-action add-new-h2",
        toolTipTitle: "i18n.creatable2ToolTipTitle",
        toolTipText: "i18n.creatable2ToolTipText",
        label: "+",
        onClick: "handleCreatableClickGallery"
      },
      creatableBackButton: {
        cssClasses: "page-title-action add-new-h2",
        label: "i18n.cancel",
        onClick: "handleCreatableClickBackButton"
      },
      // Toolbar buttons
      availableToolbarButtons: (rmlOpts.others.isPro || rmlOpts.others.showProHints ? "locked,usersettings,order,reload,rename,trash,sort,details" : "locked,usersettings,reload,rename,trash,sort,details").split(","),
      toolbar_usersettings: {
        content: "ICON_SETTINGS",
        visible: !!+rmlOpts.others.userSettings,
        toolTipTitle: "i18n.userSettingsToolTipTitle",
        toolTipText: "i18n.userSettingsToolTipText",
        onClick: "handleUserSettingsClick"
      },
      toolbar_locked: {
        content: "ICON_LOCKED",
        visible: false,
        toolTipTitle: "i18n.lockedToolTipTitle",
        toolTipText: "" // Lazy

      },
      toolbar_order: {
        content: "ICON_ORDER",
        toolTipTitle: "i18n.orderToolTipTitle",
        toolTipText: "i18n.orderToolTipText",
        onClick: "handleOrderClick",
        onCancel: "handleOrderCancel",
        menu: "resolve.renderOrderMenu",
        toolTipPlacement: "topLeft",
        dropdownPlacement: "bottomLeft"
      },
      toolbar_reload: {
        content: "ICON_RELOAD",
        toolTipTitle: "i18n.refreshToolTipTitle",
        toolTipText: "i18n.refreshToolTipText",
        onClick: "handleReload"
      },
      toolbar_rename: {
        content: "ICON_RENAME",
        toolTipTitle: "i18n.renameToolTipTitle",
        toolTipText: "i18n.renameToolTipText",
        onClick: "handleRenameClick",
        onCancel: "handleRenameCancel",
        disabled: true
      },
      toolbar_trash: {
        content: "ICON_TRASH",
        toolTipTitle: "i18n.trashToolTipTitle",
        toolTipText: "i18n.trashToolTipText",
        modifier: "handleTrashModifier",
        disabled: true
      },
      toolbar_sort: {
        content: "ICON_SORT",
        toolTipTitle: "i18n.sortToolTipTitle",
        toolTipText: "i18n.sortToolTipText",
        onClick: "handleSortClick",
        onCancel: "handleSortCancel",
        menu: "resolve.renderSortMenu",
        toolTipPlacement: "topLeft",
        dropdownPlacement: "bottomLeft"
      },
      toolbar_details: {
        content: "ICON_ELLIPSIS",
        disabled: true,
        toolTipTitle: "i18n.detailsToolTipTitle",
        toolTipText: "i18n.detailsToolTipText",
        onClick: "handleDetailsClick"
      },
      toolbarBackButton: {
        label: "i18n.cancel",
        save: "i18n.save"
      },
      // Multitoolbar buttons
      availableMultiToolbarButtons: "trash".split(","),
      multiToolbar_trash: {
        content: "ICON_TRASH",
        toolTipTitle: "i18n.trashToolTipTitle",
        toolTipText: "i18n.trashMultipleToolTipText",
        modifier: "handleMultipleTrashModifier"
      },
      // AIO
      isResizable: !_isMobile,
      isSticky: !_isMobile,
      isStickyHeader: !_isMobile,
      isFullWidth: _isMobile,
      style: _isMobile ? {
        marginLeft: 10
      } : {},
      isSortable: true,
      isSortableDisabled: true,
      isTreeBusy: false,
      isBusyHeader: false,
      headerStickyAttr: {
        top: "#wpadminbar"
      },
      isCreatableLinkDisabled: false,
      toolbarActiveButton: undefined,
      isTreeLinkDisabled: false,
      onResizeOpposite: isMaterialWp() && materialWpResizeOpposite
    }; // What happens if the attachments browser is available? We will add a reference to this React element

    _this.attachmentsBrowser && (_this.attachmentsBrowser.controller.$RmlAppTree = _assertThisInitialized(_this));
    /**
     * Called on initialzation and allows you to modify the init state.
     *
     * @callback module:AppTree~AppTree~init
     * @param {object} state The default state
     * @param {AppTree} tree The AppTree component instance
     * @returns {object} The new state
     */

    _props.init && (_this.state = _props.init(_this.state, _assertThisInitialized(_this)));
    /**
     * The React AppTree instance gets constructed and you can modify it here.
     *
     * @event module:util/hooks#tree/init
     * @param {object} state
     * @param {object} props
     * @this module:AppTree~AppTree
     */

    hooks.call("tree/init", [_this.state, _props], _assertThisInitialized(_this));
    _this.initialSelectedId = _this.state.initialSelectedId;
    return _this;
  }
  /**
   * Render AIO tree with tax switcher.
   */


  _createClass(AppTree, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      //{ metaBoxId !== false && (<MetaBox treeInstance={ this } patcher={ patcher => (this.metaboxPatcher = patcher) }
      // busy={ isBusyHeader } errors={ metaBoxErrors } id={ metaBoxId } />) }
      var _this$props$store = this.props.store,
          staticTree = _this$props$store.staticTree,
          tree = _this$props$store.tree,
          _this$state2 = this.state,
          metaBoxId = _this$state2.metaBoxId,
          rearrangeBoxId = _this$state2.rearrangeBoxId,
          showProFeature = _this$state2.showProFeature;
      return /*#__PURE__*/React.createElement(AIOTree, _extends({
        ref: this.doRef,
        id: this.props.id,
        rootId: +rmlOpts.others.rootId,
        staticTree: staticTree,
        tree: tree.length > 0 ? tree : [],
        opposite: document.getElementById("wpbody-content"),
        onSelect: this.handleSelect,
        onCloseMultiToolbar: this.handleCloseMultiToolbar,
        onRenameClose: this.handleRenameClose,
        onAddClose: this.handleAddClose,
        onCheck: this.handleCheck,
        onNodeExpand: this.handleDelayedDroppable,
        onSearchResult: this.handleDelayedDroppable,
        renderItem: this.onTreeNodeRender,
        renderIcon: this.onTreeNodeRenderIcon,
        onNodePressF2: this.handleRenameClick,
        onSort: this.handleSort,
        onResize: this.handleResize,
        headline: /*#__PURE__*/React.createElement("span", {
          style: {
            paddingRight: 5
          }
        }, i18n("folders")),
        renameSaveText: this.stateRefs.ICON_SAVE,
        renameAddText: this.stateRefs.ICON_SAVE,
        noFoldersTitle: i18n("noFoldersTitle"),
        noFoldersDescription: i18n("noFoldersDescription"),
        noSearchResult: i18n("noSearchResult"),
        innerClassName: "wrap",
        theme: "wordpress",
        creatable: this.renderCreatables(),
        toolbar: this.renderToolbarButtons(),
        multiToolbar: this.renderToolbarButtons(true),
        forceSortableFallback: true,
        allowMultiSelect: true
      }, this.state, {
        // Sortable
        sortableDelay: this.state.isSortableDisabled ? 150 : 0,
        isSortableDisabled: false
      }), rmlOpts.others.showTaxImportNotice && /*#__PURE__*/React.createElement(Alert, {
        message: /*#__PURE__*/React.createElement("span", null, rmlOpts.others.lang.sidebarDetectedTax, " ", /*#__PURE__*/React.createElement("a", {
          href: rmlOpts.others.taxImportNoticeLink
        }, rmlOpts.others.lang.sidebarDetectedTaxImport), " ", "\xB7", " ", /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: this.handleDismissImportTaxNotice
        }, rmlOpts.others.lang.sidebarDetectedTaxDismiss)),
        type: "info",
        style: {
          marginBottom: "10px"
        }
      }), rmlOpts.others.showLicenseNotice && /*#__PURE__*/React.createElement(Alert, {
        message: /*#__PURE__*/React.createElement("span", null, rmlOpts.others.lang.noProductLicense, " ", /*#__PURE__*/React.createElement("a", {
          href: rmlOpts.others.pluginsUrl
        }, rmlOpts.others.lang.enterLicense), " \xB7", " ", /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: this.handleDismissLicenseNotice
        }, rmlOpts.others.lang.licenseNoticeDismiss)),
        type: "info",
        style: {
          marginBottom: "10px"
        }
      }), !rmlOpts.others.isPro && rmlOpts.others.showProHints && rmlOpts.others.showLiteNotice && /*#__PURE__*/React.createElement(ProFooter, {
        dismissible: true,
        feature: "sidebar"
      }), /*#__PURE__*/React.createElement(ProBox, {
        feature: showProFeature,
        onClose: function onClose() {
          return _this4.setState({
            showProFeature: undefined
          });
        }
      }), /*#__PURE__*/React.createElement(MetaBox, {
        id: metaBoxId,
        onClose: function onClose(status, response) {
          return _this4._handleDetails(undefined, status, response);
        }
      }), /*#__PURE__*/React.createElement(RearrangeBox, {
        id: rearrangeBoxId,
        onClose: function onClose() {
          return _this4.setState({
            rearrangeBoxId: undefined
          });
        },
        onSort: this.handleSortManual
      }));
    }
    /**
     * @returns {object}
     */

  }, {
    key: "resolveStateRefs",
    value:
    /**
     * Iterates all available values in an object and resolve it with the available
     * this::stateRefs.
     *
     * @returns {object}
     */
    function resolveStateRefs(_obj, keys) {
      var obj = Object.assign({}, _obj);
      var value, newValue;

      for (var key in obj) {
        if ( // eslint-disable-next-line no-prototype-builtins
        obj.hasOwnProperty(key) && (value = obj[key]) && this.stateRefs[keys].indexOf(key) > -1 && typeof value === "string" && (newValue = this.resolveStateRef(value))) {
          obj[key] = newValue;
        }
      }

      return obj;
    }
    /**
     * Resolve single state ref key.
     *
     * @returns {object}
     */

  }, {
    key: "resolveStateRef",
    value: function resolveStateRef(key) {
      if (typeof key !== "string") {
        return;
      }

      if (key.indexOf("i18n.") === 0) {
        return i18n(key.substr(5));
      } else if (key.indexOf("resolve.") === 0) {
        return this.stateRefs[key.substr(8)]();
      } else if (this.stateRefs[key]) {
        return this.stateRefs[key];
      }
    }
  }, {
    key: "componentWillUnmount",
    value:
    /**
     * Remove resize handler.
     */
    function componentWillUnmount() {
      $(window).off("resize", this.handleWindowResize);
      /**
       * The React AppTree instance gets unmounted.
       *
       * @event module:util/hooks#tree/destroy
       * @param {object} state
       * @param {object} props
       * @this module:AppTree~AppTree
       */

      hooks.call("tree/destroy", [this.state, this.props], this);
    }
    /**
     * Initiate draggable and droppable
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Fetch initial tree
      this.fetchTree(this.initialSelectedId);
      draggable(this);
      droppable(this);
      this.handleResize(); // If order should be enabled in list mode, then activate it now

      if (rmlOpts.others.listMode === "list" && window.location.hash === "#order") {
        this.handleOrderClick();
        window.location.hash = "";
      }
    }
    /**
     * When the component updates the droppable zone is reinitialized.
     * Also the toolbar buttons gets disabled or enabled depending on selected node.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var selectedCreatableType = this.state.selectedCreatableType,
          selected = this.getTreeItemById();

      if (selected && selectedCreatableType !== selected.properties.type || !selected && selectedCreatableType !== undefined) {
        this._updateCreatableButtons(selected ? selected.properties.type : undefined);
      } // Enable / Disable toolbar buttons


      this._updateToolbarButtons(); // Enable locked toolbar item


      createLockedToolTipText(this);
      draggable(this);
      droppable(this);
    }
    /**
     * Return the backbone filter view for the given attachments browser.
     *
     * @returns object
     */

  }, {
    key: "getBackboneFilter",
    value: function getBackboneFilter() {
      var attachmentsBrowser = this.attachmentsBrowser;
      return attachmentsBrowser && attachmentsBrowser.toolbar.get("rml_folder");
    }
    /**
     * Get the selected node id.
     *
     * @returns {string|int}
     */

  }, {
    key: "getSelectedId",
    value: function getSelectedId() {
      return this.props.store.selectedId;
    }
    /**
     * Get tree item by id.
     *
     * @param {string|int} [id=Current]
     * @param {boolean} [excludeStatic=true]
     * @returns {object} Tree node
     */

  }, {
    key: "getTreeItemById",
    value: function getTreeItemById() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelectedId();
      var excludeStatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.props.store.getTreeItemById(id, excludeStatic);
    }
    /**
     * Update a tree item by id.
     *
     * @param {function|array} callback The callback with one argument (node draft) and should return the new node.
     * @param {string|int} [id=Current] The id which should be updated
     * @param {boolean} [setHash] If true the hash node is changed so a rerender is forced
     */

  }, {
    key: "updateTreeItemById",
    value: function updateTreeItemById(callback) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getSelectedId();
      var setHash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var node = this.props.store.getTreeItemById(id);
      node && node.setter(callback, setHash);
    }
    /**
     * Updates the create node. That's the node without id and the input field.
     *
     * @param {object} modifier The modifier object which is passed through Object.assign
     */

  }, {
    key: "updateCreateNode",
    value: function () {
      var _updateCreateNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(modifier) {
        var createRoot, node;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // Root update
                createRoot = this.state.createRoot;
                createRoot && this.setState({
                  createRoot: immer.produce(createRoot, modifier)
                }); // Child node update

                node = this.getTreeItemById();
                node && node.$create && this.updateTreeItemById(function (node) {
                  var obj = _objectSpread({}, node.$create);

                  modifier(obj);
                  node.$create = obj;
                }, undefined, true);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateCreateNode(_x9) {
        return _updateCreateNode.apply(this, arguments);
      }

      return updateCreateNode;
    }()
    /**
     * Disable the checked property for all checked nodes.
     *
     * @method
     */

  }, {
    key: "handleDestroy",
    value: function handleDestroy() {
      this.ref && ReactDOM.unmountComponentAtNode(this.ref.container.parentNode);
    }
    /**
     * Dismiss the license notice for a given time (transient).
     *
     * @method
     */

  }, {
    key: "_handleBackboneFilterSelection",
    value:
    /**
     * Set the attachments browser location.
     *
     * @param {int} [id=Current selected id] The id
     */
    function _handleBackboneFilterSelection() {
      var _this5 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelectedId();
      var attachmentsBrowser = this.attachmentsBrowser;

      if (attachmentsBrowser && id !== ID_NONE) {
        setTimeout(function () {
          var backboneFilter = _this5.getBackboneFilter();

          backboneFilter && backboneFilter.$el.val(id).change(); // Reset bulk select in no-modal mode

          attachmentsBrowser.$el.parents(".media-modal").length === 0 && attachmentsBrowser.controller.state().get("selection").reset(); // Check if folder needs refresh

          var store = _this5.props.store;

          if (store.foldersNeedsRefresh.indexOf(id) > -1) {
            store.removeFoldersNeedsRefresh(id);

            _this5.handleReload();
          }
        }, 0);
      }
    }
    /**
     * Update the creatable buttons regarding the selected type.
     *
     * @param {int} selectedCreatableType
     */

  }, {
    key: "_updateCreatableButtons",
    value: function _updateCreatableButtons(selectedCreatableType) {
      var _this6 = this;

      this.setState({
        selectedCreatableType: selectedCreatableType
      });
      this.state.availableCreatables.forEach(function (c) {
        return _this6.setState(_defineProperty({}, "creatable_" + c, Object.assign(_this6.state["creatable_" + c], {
          visible: _this6.state["creatable_" + c].visibleInFolderType.indexOf(selectedCreatableType) > -1
        })));
      });
    }
  }, {
    key: "_updateToolbarButtons",
    value: function _updateToolbarButtons() {
      var _this$state3 = this.state,
          isWPAttachmentsSortMode = _this$state3.isWPAttachmentsSortMode,
          toolbar_order = _this$state3.toolbar_order,
          toolbar_rename = _this$state3.toolbar_rename,
          toolbar_trash = _this$state3.toolbar_trash,
          toolbar_details = _this$state3.toolbar_details,
          selected = this.getTreeItemById(),
          disableIfStatic = !selected,
          restrictions = selected && selected.properties && selected.properties.restrictions || [];
      var disableOrder = disableIfStatic || isWPAttachmentsSortMode || selected && selected.contentCustomOrder === 2 || selected && selected.orderAutomatically;
      toolbar_order.disabled !== disableOrder && this.setState({
        toolbar_order: Object.assign(toolbar_order, {
          disabled: disableOrder
        })
      });
      var disableRename = disableIfStatic || restrictions.indexOf("ren") > -1;
      toolbar_rename.disabled !== disableRename && this.setState({
        toolbar_rename: Object.assign(toolbar_rename, {
          disabled: disableRename
        })
      });
      var disableTrash = disableIfStatic || restrictions.indexOf("del") > -1;
      toolbar_trash.disabled !== disableTrash && this.setState({
        toolbar_trash: Object.assign(toolbar_trash, {
          disabled: disableTrash
        })
      });
      toolbar_details.disabled !== disableIfStatic && this.setState({
        toolbar_details: Object.assign(toolbar_details, {
          disabled: disableIfStatic
        })
      });
    }
    /**
     * Fetch folder tree.
     */

  }, {
    key: "fetchTree",
    value: function () {
      var _fetchTree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(setSelectedId) {
        var _yield$this$props$sto, slugs;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.setState({
                  isTreeBusy: true
                });
                _context10.prev = 1;
                _context10.next = 4;
                return this.props.store.fetchTree(setSelectedId);

              case 4:
                _yield$this$props$sto = _context10.sent;
                slugs = _yield$this$props$sto.slugs;
                // Modify all available attachments browsers filter
                $(FILTER_SELECTOR).each(function () {
                  var backboneFilter = $(this).data("backboneView"); // Clone to remove immutability

                  backboneFilter && backboneFilter.createFilters(JSON.parse(JSON.stringify(slugs)));
                });

                this._handleBackboneFilterSelection();

                latestQueriedFolder.node = this.props.store.selected;
                _context10.next = 14;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10["catch"](1);
                console.log(_context10.t0);

              case 14:
                // Modify this tree
                this.setState({
                  isTreeBusy: false
                });

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[1, 11]]);
      }));

      function fetchTree(_x10) {
        return _fetchTree.apply(this, arguments);
      }

      return fetchTree;
    }()
    /**
     * Update the folder count. If you pass no argument the folder count is
     * requested from server.
     *
     * @param {object} counts Key value map of folder and count
     */

  }, {
    key: "fetchCounts",
    value: function () {
      var _fetchCounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(counts) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.props.store.fetchCounts(counts);

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function fetchCounts(_x11) {
        return _fetchCounts.apply(this, arguments);
      }

      return fetchCounts;
    }()
  }]);

  return AppTree;
}(React.Component)) || _class) || _class);
export default AppTree;